import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  percentDif: {
    textAlign: "right",
    color: "green",
  },
}));

export default function AnalyticCard(details) {
  const classes = useStyles();
  return (
    <Paper elevation={1} className={classes.paper}>
      <Typography className={classes.percentDif} variant="p" component="p">
        {details.diff}
      </Typography>
      <Typography variant="h4" component="h2">
        {details.stat}
      </Typography>
      <Typography variant="h6" component="h6">
        {details.title}
      </Typography>
    </Paper>
  );
}
